export default __webpack_public_path__ + "static/media/javascript.db4da075.svg";